import AboutAlpaaGO from "./Default/AboutAlpaaGO";

export default AboutAlpaaGO;
